module.exports = __webpack_public_path__ + "img/block-1.8c480c5e.jpg";